import * as React from 'react'
import { Badge, badges } from '@amzn/dvui/dist/Badge'
import { Icon, IconType } from '@amzn/dvui/dist/Icon'
import * as WpsRuntime from 'DVWebNodeWpsRuntime'
import { roundValue } from '../../utils/numberUtils'
import * as st from './imdbScore.module.scss'
import { withLocalization, LocalizerProps } from '../localizer/localizer'
import { StringId } from '../localizer/stringId'

export interface IImdbScoreBadgeProps {
  imdb?: WpsRuntime.atv.wps.ImdbFragmentModelProps
}

type LocalizedImdbRatingProps = IImdbScoreBadgeProps & LocalizerProps
const ImdbScoreWithLocalization = ({ imdb, getString }: LocalizedImdbRatingProps) => (
  imdb && imdb.score &&
  (<Badge className={st.wrapper} use={badges.TEXT}>
    <Icon className={st.imdbLogo} use={IconType.LOGO_IMDB}/>
    <span data-automation-id="imdb-rating-badge" aria-label={getString(StringId.DV_DP_ARIA_imdb_rating, { ratingValue: roundValue(imdb.score, 10).toString() })}>{imdb.scoreFormatted}</span>
  </Badge>) || null
)

export const ImdbScore = withLocalization(ImdbScoreWithLocalization)

